(ns minorodata.connections.sources.optimove
  (:require [minorodata.app.utils :as app.utils]))


(def source
  {:enabled      true
   :id           "optimove"
   :name         "Optimove"
   :image-source "optimove.png"
   :description  "Like a machine gun for marketing operations"
   :tags         ["marketing"]


   :preview-formatter
   (fn []
     (str "Authenticated by username and password"))

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [username password api-number name description]} data]
        {:source-type "optimove"
         :name        name
         :description description

         :source      {:api-number api-number
                       :credentials {:username username
                                     :password password}}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [credentials api-number]} source]
        (merge {:name        name
                :description description
                :api-number  api-number}
               (select-keys credentials [:username :password]))))

    :validate (constantly nil)

    :id :optimove-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}

             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :input
              :label      "Username"
              :name       :username
              :required   true
              :value      ""}

             {:block-type :input
              :label      "Password"
              :name       :password
              :type       :password
              :required   true
              :value      ""}

             {:block-type :input
              :label      "API Number"
              :name       :api-number
              :required   true
              :value      ""}

             {:content "Different Optimove customers are assigned different API servers, accessed using different base URIs. Optimove's Support Team informs each customer of the correct base URI for them to use, which contains the API number"}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status report action destination-table]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:action            action
                    :report            report
                    :destination-table destination-table}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:destination-table :report :action])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status
           :output-tables []}))))

    :validate (constantly nil)

    :id :optimove-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}

             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :select
              :label      "Report"
              :name       :report
              :options    [{:name "Get actions"  :value "actions"}
                           {:name "Get channel templates"  :value "channel-templates"}
                           {:name "Campaign details"  :value "campaign-details"}
                           {:name "Campaign interactions"  :value "campaign-interactions"}
                           {:name "Customer send details by campaign"  :value "send-details-campaign"}
                           {:name "Customer send details by channel"  :value "send-details-channel"}]
              :required   true
              :value      "actions"}

             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:eq [:action :value] "append"]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
